/* global fetch, Babel */
import React from "react";
import Fridge from "../fridge";
import Registry from "../registry";

// set up globals
window.React = React;
window.Fridge = Fridge;
// window.require = () =>

let scripts = [];
let magnetCache = {};
let decorators = {};

const addScript = script => {
  if (document.currentScript) {
    document.currentScript.parentNode.insertBefore(
      script,
      document.currentScript
    );
  } else {
    (document.head || document.getElementsByTagName("head")[0]).appendChild(
      script
    );
  }
};

const loadMagnet = async magnet => {
  if (magnetCache[magnet]) {
    return magnetCache[magnet];
  }

  try {
    const res = await fetch(magnet);
    const text = await res.text();
    window.exports = {};

    let script = document.createElement("script");
    // console.log(transform(text))
    // we can use metadata here for further introspection
    script.text = transform(text).code;
    addScript(script);
    scripts.push(script);

    // TODO: How to handle errors from the script?
    // return reject(new Error(`Failed to load ${magnet}`))
    magnetCache[magnet] = window.exports;
    return window.exports;
  } catch (err) {
    // TODO: Alert in UI
    console.log(`Failed to load ${magnet}`);
    console.log(err);
    return {};
  }
};

const getMagnetUrl = magnet => {
  // magnet is a url to a file
  if (magnet.match(/^http[s]?/)) return magnet;

  // magnet is a node module
  // ?module
  // Would like to use ?module to resolve import
  // statements, but it breaks when using jsx
  return `https://unpkg.com/${magnet}`;
};

export const loadMagnets = async site => {
  const magnets = site.magnets || [];
  unloadMagnets();

  if (!magnets.length) return site;

  if (!window.Babel) {
    await new Promise((resolve, reject) => {
      const script = document.createElement("script");
      // script.async, script.defer
      script.src = "https://unpkg.com/@babel/standalone/babel.min.js";
      script.onload = script.onreadystatechange = e => {
        resolve();
      };
      addScript(script);
    });
  }

  await Promise.all(
    magnets.map(async magnet => {
      const url = getMagnetUrl(magnet);
      const mod = await loadMagnet(url);
      if (mod.decorateTypeOptions) {
        addDecorator("typeOptions", mod.decorateTypeOptions);
      }

      window.exports = {};
    })
  );

  return site;
};

export const unloadMagnets = () => {
  Registry.unregisterCustom();
  scripts.forEach(script => script.parentNode.removeChild(script));
  scripts = [];
  magnetCache = {};
  decorators = {};
};

// export const magnetMiddleware = store => next => action => {
//   let result = next(action)
//   return result
// }

export const addDecorator = (name, fn) => {
  if (!decorators[name]) {
    decorators[name] = [];
  }

  decorators[name].push(fn);
};

export const getDecorated = (name, fn) => {
  return (...args) => {
    const fns = (decorators[name] || []).reverse();
    // TODO wrap in try/catch for error handling
    // we pass args to the decorators so they can get more params
    // but still reduce the single return value. (acc, ...args)
    // we might want to change this or set up two functions.
    return fns.reduce((acc, f) => f(acc, ...args), fn(...args));
  };
};

const transform = code => {
  return Babel.transform(code, {
    presets: ["es2015", "stage-3", "react"]
  });
};



// WEBPACK FOOTER //
// ./app/lib/magnets.js